import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FOUNDING_COHORT_TARGETS } from "../../../../constants/automapFoundingDealerConstants";
import { fetchFoundingDashboard } from "../../../../services/automapFoundingDealerApi";
import { CopyTemplateButton, FoundingShell } from "./AdminFoundingShared";

export default function AdminFoundingDashboardPage() {
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchFoundingDashboard()
      .then(setPayload)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const summary = payload?.summary;
  const cohort = payload?.cohort?.metrics;

  return (
    <FoundingShell
      active="dashboard"
      title="Dealers fundadores"
      description="Pipeline, readiness e inventario para el lanzamiento en Medellín/Antioquia."
      viewEvent="founding_dealer_dashboard_viewed"
    >
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error && summary ? (
        <>
          <div className="dashboard-summary-grid">
            {[
              { label: "Pipeline total", value: summary.pipelineTotal },
              { label: "Prospectos", value: summary.prospects },
              { label: "Interesados", value: summary.interested },
              { label: "En onboarding", value: summary.onboarding },
              { label: "Launch-ready", value: summary.launchReady },
              { label: "Activos", value: summary.active },
              { label: "Dealers fundadores", value: summary.foundingDealers },
              { label: "Tareas abiertas", value: summary.openTasks },
            ].map((item) => (
              <div key={item.label} className="dashboard-summary-card">
                <span className="dashboard-summary-label">{item.label}</span>
                <strong className="dashboard-summary-value">{item.value}</strong>
              </div>
            ))}
          </div>
          {cohort ? (
            <section className="dealer-state-box">
              <h3>Progreso hacia lanzamiento</h3>
              <p>
                Meta dealers: {FOUNDING_COHORT_TARGETS.minLaunchReadyDealers}–
                {FOUNDING_COHORT_TARGETS.targetLaunchReadyDealers} · Listings limpios:{" "}
                {FOUNDING_COHORT_TARGETS.minCleanListings}+
              </p>
              <ul>
                <li>Launch-ready: {cohort.launchReadyDealers}</li>
                <li>Listings activos: {cohort.totalActiveListings}</li>
                <li>Listings limpios: {cohort.cleanListings}</li>
                <li>Cobertura fotos: {cohort.photoCoveragePct}%</li>
                <li>Frescura: {cohort.freshnessPct}%</li>
              </ul>
              <Link to="/admin/dealers/founding/readiness">Ver readiness completo →</Link>
            </section>
          ) : null}
          <section className="dealer-state-box">
            <h3>Plantillas de outreach</h3>
            <div className="admin-analytics-grid">
              {Object.entries(payload.outreachTemplates || {}).map(([key, text]) => (
                <CopyTemplateButton key={key} label={key.replace(/_/g, " ")} text={text} />
              ))}
            </div>
          </section>
          <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
            <Link className="dealer-portal-btn" to="/admin/dealers/founding/pipeline">
              Ver pipeline
            </Link>
            <Link className="dealer-portal-btn" to="/admin/dealers/founding/tasks">
              Ver tareas
            </Link>
          </div>
        </>
      ) : null}
    </FoundingShell>
  );
}
